module.exports = __webpack_public_path__ + "static/home3-20efd9d94ab327858d180f82fe4e8e1a.jpg";